const TEXT_FIELD_SINGLE_LINE =
  'com.atlassian.jira.plugin.system.customfieldtypes:textfield';

// TODO: https://soldevelo.atlassian.net/browse/ATESTM-3222
export default {
  mapValue(mappingItem, row, fieldsMap, delimiter) {
    const field = fieldsMap[mappingItem.to?.value];
    switch (field?.schema.type) {
      case 'user':
        return { id: row[mappingItem.from.value] };
      case 'string':
        return mapString(field, mappingItem, row);
      case 'number':
        return Number(row[mappingItem.from.value]);
      case 'array':
        return mapArray(mappingItem, row, delimiter);
      case 'option':
        return {
          value: row[mappingItem.from.value],
        };
    }
  },
};

function mapArray(mappingItem, row, delimiter) {
  const arrayType = mappingItem.to?.arrayType;

  switch (arrayType) {
    case 'component':
    case 'version':
      return row[mappingItem.from.value]
        .split(delimiter)
        .filter((value) => value)
        .map((value) => value.trim())
        .map((value) => ({
          name: value,
        }));
    case 'option':
      return row[mappingItem.from.value]
        .split(delimiter)
        .filter((value) => value)
        .map((value) => value.trim())
        .map((value) => ({
          value: value,
        }));
    default:
      return row[mappingItem.from.value]
        .split(delimiter)
        .filter((value) => value)
        .map((value) => value.trim())
        .map((value) => value);
  }
}

function mapString(field, mappingItem, row) {
  return field?.schema.custom === TEXT_FIELD_SINGLE_LINE
    ? row[mappingItem.from.value]
    : {
        type: 'doc',
        version: 1,
        content: [
          {
            type: 'paragraph',
            content: [{ text: row[mappingItem.from.value], type: 'text' }],
          },
        ],
      };
}
